import {EventsHttpClient} from '@wix/wix-events-commons-statics'
import type {ControllerParams, IHttpClient} from '@wix/yoshi-flow-editor'
import {instanceGetterFactory} from '../services/instance'
import {getLinguisticHeader} from '../services/multilingual'
import {getLanguage, getLocale, getTimezone} from './wix-code-api'

export class Api {
  controller: ControllerParams['controllerConfig']
  getInstance: () => string
  instanceId: string
  compId: string
  viewMode: string
  language: string
  locale: string
  tz: string
  api: EventsHttpClient
  writeApi: EventsHttpClient
  httpClient: IHttpClient
  errorHandler: ControllerParams['flowAPI']['errorHandler']

  constructor(controllerParams: ControllerParams) {
    this.httpClient = controllerParams.flowAPI.httpClient
    this.controller = controllerParams.controllerConfig
    this.getInstance = instanceGetterFactory(this.controller)
    this.instanceId = this.controller.appParams.instanceId
    this.compId = this.controller.compId
    this.viewMode = this.controller.wixCodeApi.window.viewMode.toLowerCase()
    this.language = getLanguage(this.controller.wixCodeApi)
    this.locale = getLocale(this.controller.wixCodeApi)
    this.tz = getTimezone(this.controller.wixCodeApi)
    this.errorHandler = controllerParams.flowAPI.errorHandler

    this.api = new EventsHttpClient(this.httpClient, undefined, getLinguisticHeader(this.controller), this.errorHandler)
    this.writeApi = new EventsHttpClient(
      this.httpClient,
      '/_api/events-viewer-write-facade',
      getLinguisticHeader(this.controller),
      this.errorHandler,
    )
  }
}
